import { useReactiveVar } from '@apollo/client';
import React from 'react';
import { Link, useHistory } from 'react-router-dom';
import Swal from 'sweetalert2';
import { isLoggedInVar } from '../../apollo';
import { jwtToken } from '../../apollo';
function Header() {
    const isLoggedIn = useReactiveVar(isLoggedInVar);
    const token = useReactiveVar(jwtToken);
    const menuMouseOver = () => {
        document.querySelector('#header')?.classList.add('active');
    };
    const menuMouseOut = () => {
        document.querySelector('#header')?.classList.remove('active');
    };

    const history = useHistory();

    //아직 미완성된 페이지 클릭시 팝업
    async function onClickMyPage() {
        await Swal.fire({
            text: '페이지 준비중 입니다.',
        });
    }

    // 로그인체크
    async function onClickCheckLogin() {
        const confirm = await Swal.fire({
            title: '로그인',
            text: '로그인 후 이용해 주시기 바랍니다.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: '로그인',
            cancelButtonText: '취소',
        });
        if (confirm.isConfirmed) {
            history.push('/member/login'); //router init
        }
    }

    const empSessionURL = `http://www.playauto.co.kr/_mem/help_list.html?&playapi=Y&token=${token}&noHeader=Y&noFooter=Y&q=`;
    //logout시 팝업
    async function checkLogout() {
        const confirm = await Swal.fire({
            title: '확인',
            text: '로그아웃하시겠습니까?',
            showConfirmButton: true,
            showCancelButton: true,
        });
        if (confirm.isConfirmed) {
            sessionStorage.removeItem('jwttoken'); //jwt token init
            isLoggedInVar(false); //global var init
            history.push('/'); //router init
        }
    }
    return (
        <div id="header">
            <div>
                <h1>
                    <Link to="/">
                        <img alt="main" src="https://cloud.plto.com/design/logo/logo_main.png" />
                    </Link>
                </h1>
                <ul className="gnb" onMouseOver={menuMouseOver} onMouseOut={menuMouseOut}>
                    <li>
                        API 소개
                        <ul className="lnb">
                            <li>
                                <Link to="/info/playApiIntro">PLAY API</Link>
                            </li>
                            <li>
                                <Link to="/info/playApiExample">연동사례</Link>
                            </li>
                        </ul>
                    </li>
                    <li>
                        API 가이드
                        <ul className="lnb">
                            <li>
                                <Link to="/guide/playApiGuide">API 개요</Link>
                            </li>
                            <li>
                                {/* {!isLoggedIn && <Link to="/member/login">API 문서</Link>} */}
                                {!isLoggedIn && <span onClick={onClickCheckLogin}>API 문서</span>}
                                {isLoggedIn && <Link to="/guide/playApiOutDocs">API 문서</Link>}
                            </li>
                        </ul>
                    </li>
                    <li>
                        문의하기
                        <ul className="lnb">
                            <li>
                                <Link to="/info/IntroMethod">도입문의</Link>
                            </li>
                            <li>
                                <a href={empSessionURL} target="blank">
                                    1:1 문의하기
                                </a>
                            </li>
                        </ul>
                    </li>
                </ul>
                {isLoggedIn && (
                    <div>
                        <button onClick={onClickMyPage}>
                            나의정보{/* <Link to="/member/mypage">나의정보</Link> */}
                        </button>
                        <button onClick={checkLogout}>로그아웃</button>
                    </div>
                )}
                {!isLoggedIn && (
                    <div>
                        <button>
                            <Link to="/member/login">로그인</Link>
                        </button>
                        <button>
                            <a href="https://plto.com/register/Register/" target="blank">
                                회원가입
                            </a>
                        </button>
                    </div>
                )}
            </div>
        </div>
    );
}

export default Header;
